<template>
    <div>
        <vs-popup title="Criar Conexão" 
            :button-close-hidden="false" 
            :active.sync="isActive"
            @close="close()"
            id="create-instance-popup"
        > 
            <div>
                <h5 style="color: #646464"> A conexão será criada para a Dash de nome "{{ tenantName }}" </h5> 
                <vs-input label="Nome da Conexão" v-model="instanceName" class="mt-5 w-full" name="tenantName"/>
                <span class="text-danger text-sm" v-show="errors.has('tenantName')">
                    {{ errors.first('tenantName') }}
                </span>

                <div class="align-div-of-create-instance-modal">
                    <span class="align-span-of-create-instance-modal">
                        <div>
                            <vs-checkbox v-model="isOfficial" size="small">
                                Conexão Oficial
                            </vs-checkbox>
                        </div>
                        
                        <div>
                            <vs-checkbox v-model="isUnlimited" size="small">
                                Conexão Ilimitada
                            </vs-checkbox>
                        </div>
                    </span>
                    
                    <span>
                        <vs-button size="medium" @click="createInstance()">
                            <span> Criar </span>
                        </vs-button>
                    </span>
                </div>
                
            </div>
        </vs-popup>
    </div>
</template>

<script>
    import instanceHttp from './../../http/requests/connections/index';
    import { mapGetters } from 'vuex';

    export default {
        data() {
            return {
                instanceName: '',
                isOfficial: false,
                isUnlimited: false
            }
        },
        props: {
            isActive: {
                type: Boolean,
                required: true
            },
            tenantName: {
                type: String,
                required: true
            }
        },
        emits: [
            'isActiveFalse',
            'successfullyCreated'
        ],
        methods: {
            closePopUpCreate(){
                this.$emit('isActiveFalse');
            },
            verify(){
                const permissions = localStorage.getItem('permissions');
                const twoFactor = localStorage.getItem('twoFactor')
                if(!permissions && !twoFactor){
                    this.$router.push('/user-settings')
                }else if(!permissions && twoFactor){
                    this.$router.push('/two-factor')
                }
            },
            createInstance() {
                if (this.instanceName.trim() === '' || this.instanceName === null) {
                    return this.$vs.notify({
                        title: 'Insira o nome para prosseguir com a criação!',
                        color: 'danger'
                    });
                }

                instanceHttp.createInstance(
                    this.instanceName,
                    this.tenantName,
                    this.isOfficial,
                    this.isUnlimited,
                    this.token
                )
                .then(response => {
                    this.$vs.notify({
                        title: 'Sucesso!',
                        text: 'Conexão criada com sucesso!',
                        color: 'success'
                    });
                    return this.$emit('successfullyCreated', response);
                })
                .catch(Exception => {
                    console.log(Exception);
                    return this.$vs.notify({
                        title: 'Erro!',
                        text: 'Algo deu errado ao tentar criar a conexão!',
                        color: 'danger'
                    });
                });
            },
            close() {
                this.isOfficial  = false;
                this.isUnlimited = false;
                this.$emit('isActiveFalse');
            }
        },
        watch: {
            isActive() {
                this.isOfficial  = false;
                this.isUnlimited = false;
            },
        },
        computed: {
            ...mapGetters([
                'token'
            ])
        },
        mounted(){
            this.verify()
        },
        created(){
            this.$events.on('closePopUpCreate', this.closePopUpCreate);
        },
        beforeDestroy() {
            this.$events.off('closePopUpCreate', this.closePopUpCreate);
        }
    }
</script>

<style lang="scss">
#create-instance-popup {
    div.vs-popup {
        .vs-popup--content {
            padding: 15px;
            margin: 0;
        }
        margin: 0;
        border-color: rgba(18, 17, 17, 0.769);
        width: 500px !important;

        .align-div-of-create-instance-modal {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 10px;
        }
        .align-span-of-create-instance-modal {
            display: flex;
        }
    }
}
</style>